import { Radio, RadioGroupProps as AnvilRadioGroupProps, Flex, Icon } from '@servicetitan/anvil2';
import { get, useFormContext } from 'react-hook-form';
import Error from '@servicetitan/anvil2/assets/icons/material/round/warning.svg';

interface RadioGroupProps extends AnvilRadioGroupProps {
    name: string;
}

export const RadioGroup = ({ name, children, ...props }: RadioGroupProps) => {
    const {
        formState: { errors },
    } = useFormContext();

    const error = get(errors, name);

    return (
        <Radio.Group {...props}>
            {children}
            {error != null && (
                <Flex
                    gap="1"
                    justifyContent="flex-start"
                    alignItems="center"
                    style={{ color: 'var(--a2-foreground-color-danger)' }}
                >
                    <Icon inherit aria-hidden svg={Error} />
                    {error.message}
                </Flex>
            )}
        </Radio.Group>
    );
};
